/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_Financialcriteriadescription12Inputs */

const en_welcome_accreditation_financialcriteriadescription12 = /** @type {(inputs: Welcome_Accreditation_Financialcriteriadescription12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net worth over $1 million, excluding primary residence (individually or with spouse or partner)`)
};

/**
* | output |
* | --- |
* | "Net worth over $1 million, excluding primary residence (individually or with spouse or partner)" |
*
* @param {Welcome_Accreditation_Financialcriteriadescription12Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_accreditation_financialcriteriadescription12 = /** @type {((inputs?: Welcome_Accreditation_Financialcriteriadescription12Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_Financialcriteriadescription12Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_financialcriteriadescription12(inputs)
});
export { welcome_accreditation_financialcriteriadescription12 as "welcome_accreditation_financialCriteriaDescription1" }